import { mapActions, mapGetters } from 'vuex'

import LazyImage from '@/components/LazyImage'

export default {
  name: 'round',
  props: {
    roundId: String,
    pageArr: Object
  },
  components: {
    LazyImage
  },
  data: () => ({
    pageLoading: true,
    totalUsers: 0
  }),
  computed: {
    ...mapGetters('admin', {
      roundPredictionTrack: 'GET_ROUND_PREDICTION_TRACK'
    })
  },
  methods: {
    ...mapActions('admin', {
      fetchRoundPredictionTrack: 'FETCH_ROUND_PREDICTION_TRACK'
    })
  },
  watch: {
    pageArr(data) {
      const pageList = data.pages
      const roundId =
        parseInt(this.roundId) || pageList.find(item => item.defaultPage).param
      this.pageLoading = true
      this.fetchRoundPredictionTrack(roundId).then(() => {
        this.pageLoading = false
        const {
          usersPredicted,
          usersRandomized,
          usersUnknown
        } = this.roundPredictionTrack

        const totalUsers =
          Number(usersPredicted) +
          Number(usersRandomized) +
          Number(usersUnknown)
        this.totalUsers = totalUsers
      })
    }
  },
  deactivated() {}
}
